import { connect } from '../../../actions/integration/methods/connect'

/**
 * Initiates connection process for an integration
 * @param {number} platformId - ID of the platform to connect
 * @returns {Promise<boolean>} Success status
 */
export const connectIntegration = async (platformId) => {
  try {
    const redirectURL = `${window.location.origin}/settings?integration=${platformId}&tab=integrations`
    const authUrl = await connect(platformId, redirectURL)
    
    if (authUrl) {
      window.location.href = authUrl
      return true
    }
    return false
  } catch (error) {
    console.error('Error connecting integration:', error)
    return false
  }
}
